<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/standardList' }">考核标准</el-breadcrumb-item>
        <el-breadcrumb-item>考核标准详情/考核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="innerBox content">
      <!-- <el-divider><span style="font-size: 18px;color: #666666">详情</span></el-divider> -->
      <div style="width: 80%;margin: auto">
        <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">基础信息</span></el-divider></div>
        <div class="detailBox">
          <div>
            标准标题：
            <span>{{ obj.title }}</span>
          </div>
          <div>
            适用范围：
            <span>{{ obj.scopeApplication }}</span>
          </div>
          <div>
            标准分类：
            <span>{{ obj.classify }}</span>
          </div>
          <div>
            设定人部门：
            <span>{{ obj.employeeDepId }}</span>
          </div>
          <div>
            设定人：
            <span>{{ obj.producer }}</span>
          </div>
          <div>
            设定时间：
            <span>{{ obj.creationTime | timeFilter }}</span>
          </div>
          <div>
            合格分数：
            <span>{{ obj.passingScore }}</span>
          </div>
          <div>
            考核项目：
            <span>{{ obj.examinationItem }}</span>
          </div>
        </div>
        <div class="tableBox">
          <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">考核内容</span></el-divider></div>
          <el-table :data="tableData" style="width: 100%" ref="tableData" border
            :header-cell-style="{ fontSize: '12px',padding: '5px' }"
            :cell-style="{ padding: '5px' }">
            <el-table-column prop="goal" label="考核目标" width="180" />
            <el-table-column prop="points" label="评价要点" />
            <el-table-column prop="standard" label="标准要求和评估办法" />
            <el-table-column prop="score" label="分数" width="70" />
          </el-table>
          <div class="a" style="margin-top: 30px">
            评定标准：
            <span><pre>{{ obj.examinationCriterion }}</pre></span>
          </div>
          <div class="a">
            考核说明：
            <span><pre>{{ obj.examinationExplain }}</pre></span>
          </div>
          <div class="a">
            备&emsp;&emsp;注：
            <span><pre>{{ obj.postscript }}</pre></span>
          </div>
        </div>
        <!-- 审批流程 -->
        <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">审批流程</span></el-divider></div>
        <el-steps :active="obj.status" align-center>
          <el-step>
            <h4 slot="title">设定人</h4>
            <!-- <div slot="description" v-if="obj.status > 0"> -->
            <div slot="description">
              <div>{{ obj.creationTime }}</div>
              <div>{{ obj.producer }}</div>
              <div>发起审核</div>
              <div>{{ obj.producerExplain }}</div>
            </div>
          </el-step>
          <el-step>
            <h4 slot="title">部门审批</h4>
            <!-- <div slot="description" v-if="obj.status > 1"> -->
            <div slot="description">
              <div>{{ obj.depAuditTime }}</div>
              <div>{{ obj.departmentHeadName }}</div>
              <div v-if="obj.depAuditStatus === 0" style="color: #E6A23C">通过</div>
              <div v-if="obj.depAuditStatus === 1" style="color: red">不通过</div>
              <div>{{ obj.departmentHeadAudit }}</div>
            </div>
          </el-step>
          <el-step>
            <h4 slot="title">公司领导审批</h4>
            <!-- <div slot="description" v-if="obj.status > 2"> -->
            <div slot="description">
              <div>{{ obj.comAuditTime }}</div>
              <div>{{ obj.companyLeaderName }}</div>
              <div v-if="obj.comAuditStatus === 0" style="color: #E6A23C">通过</div>
              <div v-if="obj.comAuditStatus === 1" style="color: red">不通过</div>
              <div>{{ obj.companyLeaderAudit }}</div>
            </div>
          </el-step>
        </el-steps>
        <el-divider v-if="(obj.status > 0 || obj.producerUserId == userId) && obj.status !== 3" />
        <el-form :model="form" label-width="90px" v-if="(obj.producerUserId == userId && obj.status === 0) || (obj.departmentHeadId == userId && obj.status === 1)
          || (obj.companyLeaderId == userId && obj.status === 2)">
          <el-form-item label="是否通过" v-if="obj.status !== 0">
            <el-radio-group v-model="form.pass" size="small">
              <el-radio-button :label="0">通过</el-radio-button>
              <el-radio-button :label="1">不通过</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批意见">
            <el-input type="textarea" :rows="2" v-model="form.auditContent" />
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="examineStandard">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { standardDetail, examineStandard } from "@/api/processManager";
export default {
  name: "standardDetail",
  data() {
    return {
      userId: '',
      obj: {},
      tableData: [],
      form: {
        id: '',
        pass: 0,
        auditContent: ''
      },
    };
  },
  created() {
    this.userId = localStorage.getItem('userId');
    console.log(this.userId)
    this.form.id = this.$route.params.id
    this.getDetail();
  },
  methods: {
    getDetail() {
      standardDetail(this.$route.params.id).then(res => {
        this.obj = res.body.data;
        this.tableData = JSON.parse(res.body.data.examinedContent);
      });
    },
    // 审核
    examineStandard() {
      examineStandard({ ...this.form }).then(res => {
        this.getDetail();
        this.form.pass = 0;
        this.form.auditContent = ''
      })
    }
  }
};
</script>

<style scoped>
.detailBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.detailBox div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox > div > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
.innerBox .el-form-item {
  margin-bottom: 5px;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px
}
</style>